<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible="modalVisible"
      notFooterPadding
      size="800_auto"
  >
    <template #header>
      <span>自定义指标</span>
    </template>
    <template #content>
      <el-alert
          :title="title"
          type="success"
          :closable="false">
      </el-alert>
      <el-checkbox-group
          class="gj-checkbox-group"
          v-model="checkList"
          @change="changeCheckGroup"
      >
        <el-row v-for="item in columns" :key="item.id">
          <gj-area-title
              v-if="item.isShow"
              style="margin: 10px 0 10px;"
          >{{item.text}}</gj-area-title>
          <template v-if="item.isShow">
            <template v-if="item.children && item.children.length > 0">
              <div v-for="(childItem,childIdx) in item.children" :key="item.id + childIdx">
                <el-col
                    v-if="childItem.isShow"
                    :span="8"
                    class="gj-checkbox">
                  <el-checkbox
                      :label="childItem.id"
                      :disabled="childItem.disabled"
                      :checked="childItem.checked"
                  >
                    {{ childItem.text }}
                  </el-checkbox>
                </el-col>
              </div>
            </template>
            <template v-else>
              <el-col
                  v-if="isMeaningless(item.permission) || $permission(item.permission)"
                  :key="item.id"
                  :span="8"
                  class="gj-checkbox">
                <el-checkbox
                    :label="item.id"
                    :disabled="item.disabled"
                    :checked="item.checked">
                  {{item.name}}
                </el-checkbox>
              </el-col>
            </template>
          </template>
        </el-row>
      </el-checkbox-group>
    </template>
    <template #footer>
      <gj-button
          @click="cancel">
        取消
      </gj-button>
      <gj-button
          :loading="resetLoading"
          @click="reset">
        恢复默认设置
      </gj-button>
      <gj-button
          :loading="confirmLoading"
          type="primary"
          @click="confirm">
        确定
      </gj-button>
    </template>
  </gj-modal>
</template>

<script>
import {saveCustomColumns} from "@/api/common";
import {isMeaninglessMixin, modalMixIn} from "@/minxins";
import {settingList} from "@/utils/setting";
import _ from "lodash";
export default {
  name: "gj-setting-custom-modal",
  mixins: [modalMixIn, isMeaninglessMixin],
  props: {
    title:{
      type: String,
      default: '最多可以选择8个指标，至少选中1个指标'
    },
    // columns: {
    //   type: Array,
    //   default: settingList || []
    // },
    moduleColumns:{
      type: Array,
      default: ()=>[]
    },
    name: {
      type: String,
      required: true
    },
    /**
     * 显示多选框的项，key 值得字符串以","相隔
     */
    // customStr : {
    //   type: String,
    // },
    /**
     * 最多允许选取的指标数量, 不限量就传一个很大的数
     */
    allowNum: {
      type: Number,
    },
  },
  created() {
    const checks = this.moduleColumns.filter(e => e.checked).map(e => (e.key || e.id));
    let isOverAllowNum = checks.length >= this.allowNum;
    const customStr = this.moduleColumns.map(e=> (e.key || e.id)).join(",");
    // this.title = `最多可以选择${this.allowNum}个指标，至少选中1个指标`
    //没什么逻辑，就是二维数组里面每个 obj 加了一个 isShow 字段
    if(_.isEmpty(customStr)){
      this.columns = _.map(_.cloneDeep(this.columns), m=>{
        let children = m.children;
        m.isShow = false;
        _.map(children, n=>{
          if(_.includes(checks, n.key|| n.id)){
            n.checked = true;
            //如果有选择个数限制，才写入disabled
            if(this.allowNum){
              n.disabled = !isOverAllowNum;
            }
          } else {
            if(this.allowNum){
              n.disabled = isOverAllowNum
            }
            n.checked = null;
          }
          n.isShow = true;
          if(!m.isShow){
            m.isShow = true;
          }
          return n;
        })
        return m;
      })
      return;
    } else {
      let tiledList = customStr ? customStr.split(",") :[];    //平铺数组
      //正常流程
      this.columns = _.map(_.cloneDeep(this.columns), m=>{
        m.isShow = false;
        m.children = m.children.map(n=>{  
          if(n.keyList && _.includes(tiledList, n.keyList[0])){
            n.isShow = true;
            n.id = n.key = n.keyList[0];
            if(!m.isShow){
              m.isShow = true;
            }
          }
          if(_.includes(tiledList, (n.key || n.id))){
            n.isShow = true;
            if(!m.isShow){
              m.isShow = true;
            }
          }
          if(n.keyList && _.includes(checks, n.keyList[0])){
            n.checked = true;
            if(this.allowNum){
              n.disabled = false;
            }
          } else {
            n.checked = false;
            if(this.allowNum){
              n.disabled = isOverAllowNum;
            }
          }
          if(_.includes(checks, (n.key || n.id))){
            n.id = n.key;
            n.checked = true;
            if(this.allowNum){
              n.disabled = false;
            }
          } else {
            n.checked = false;
            if(this.allowNum){
              n.disabled = isOverAllowNum;
            }
          }
          return n;
        });
        return m;
      })
    }
  },
  data() {
    return {
      checkList: [],
      resetLoading: false,
      confirmLoading: false,
      columns: settingList || [],
    }
  },
  methods: {
    cancel() {
      this.$gjModal.$gjDestroy();
    },
    reset() {
      //这里为了兼容，只能再传一个参数，默认选中，坑爹
      this.resetLoading = true;
      const defaultCheckList = this.moduleColumns.filter(e => e.default).map(e => e.key || e.id);
      saveCustomColumns({
        module: this.name,
        columns: defaultCheckList.join(',')
      })
          .then(() => {
            this.$message.success('保存成功');
            this.$emit('check-list', defaultCheckList);
            this.$emit('moduleColumns', this.moduleColumns.map(e=> {
              if(_.includes(defaultCheckList, e.key || e.id)){
                e.checked = true;
              } else{
                e.checked = false;
              }
              return e;
            }));
            this.$emit('check-list-items', this.moduleColumns.filter(e=> _.includes(defaultCheckList, e.key||e.id)));
            this.$gjModal.$gjDestroy();
          })
          .complete(() => this.resetLoading = false);
    },
    confirm() {
      if(this.checkList.length > this.allowNum){
        this.$message.error(`最多仅能保存${this.allowNum}个`);
        return;
      }
      if(this.checkList.length ===0){
        this.$message.error(`最少需保存1个`);
        return;
      }
      this.confirmLoading = true;
      saveCustomColumns({
        module: this.name,
        columns: (this.checkList || []).join(',')
      })
          .then(() => {
            this.$message.success('保存成功');
            this.$emit('check-list', this.checkList || []);
            this.$emit('moduleColumns', this.moduleColumns.map(e=> {
              if(_.includes(this.checkList, e.key || e.id)){
                e.checked = true;
              } else{
                e.checked = false;
              }
              return e;
            }));
            this.$emit('check-list-items', this.moduleColumns.filter(e=> _.includes(this.checkList, e.key)));
            this.$gjModal.$gjDestroy();
          })
          .complete(() => this.confirmLoading = false);
    },
    changeCheckGroup(checkList){
      let isOverAllowNum = checkList.length >= this.allowNum;
      this.columns = this.columns.map(a =>{
        a.children = a.children.map(b=>{
          if(_.includes(checkList, b.key|| b.id)){
            b.checked = true;
            if(this.allowNum){
              b.disabled = false;
            }
          } else {
            if(this.allowNum){
              b.disabled = isOverAllowNum;
            }
          }
          return b;
        })
        return a;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.gj-checkbox-group {
  padding: 10px;
}
.gj-checkbox {
  margin: 6px 0;
}
/deep/ .el-alert--success {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  background-color: rgb(229, 240, 255);
  border-radius: 2px;
  border: 1px solid rgb(151, 199, 255);
}
/deep/ .gj-modal--custom .el-dialog {
  height: 600px;
  width: 800px;
}
@media (max-height: 768px) {
  /deep/ .gj-modal--custom .el-dialog {
    height: 580px;
    width: 800px;
  }
}
</style>
